import React from 'react'
import styled from '@emotion/styled'
import {NavLink} from 'react-router-dom'

const Root = styled.div`
  display: flex;
  align-items: center;
`

const Tab = styled.a`
  display: block;
  flex: 1;
  padding: 8px 21px;
  font: 14px/1.5 Merriweather, serif;
  font-weight: 300;
  text-decoration: none;
  background-color: rgba(0, 0, 0, 0.85);
  color: rgba(255, 255, 255, 0.9);
`

const ActiveTab = styled(NavLink)`
  display: block;
  flex: 1;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.25);  
  padding: 8px 21px;
  font: 14px/1.5 Merriweather, serif;
  font-weight: 500;
  text-decoration: none;
  background-color: #6fb971;
  color: white;
  
  &.active {
    cursor: default;
  }
`

const MainMenu = () => <Root>
  <Tab href='https://mageric.life/main.asp?WW_ID=26723'>Mageric</Tab>
  <Tab href='https://mageric.life/main.asp?WW_ID=2098820058'>ЭС-маркетинг</Tab>
  <Tab href='https://mageric.life/main.asp?WW_ID=26867'>Бизнес-школа</Tab>
  <ActiveTab to="/app/catalog/client" exact>Каталог</ActiveTab>
</Root>

export default MainMenu
